import script from "./SelectListDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectListDialog.vue?vue&type=script&setup=true&lang=js"

import "./SelectListDialog.vue?vue&type=style&index=0&id=d3b80340&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3b80340"]])

export default __exports__